// The site's badges each have a colour of their own, "#rrggbb", chosen in the admin panel. A badge is drawn as an
// outline and lettering in that colour over a faint wash of it.

// "#rrggbb" as "r, g, b", for use inside rgb() and rgba(); the site's light blue if it isn't a colour
export function colorParts(color) {
    let match = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color || '');
    return match ? match.slice(1).map((part) => parseInt(part, 16)).join(', ') : '176, 224, 230';
}

// The inline style that draws a badge in its colour
export function badgeStyle(color) {
    let parts = colorParts(color);
    return { borderColor: `rgb(${parts})`, color: `rgb(${parts})`, backgroundColor: `rgba(${parts}, 0.14)` };
}
